var React = require('react');

function Reorder (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"d":"M364.53,194.31c0,107.15-87.16,194.32-194.31,194.32A193.77,193.77,0,0,1,29.31,328.11a1,1,0,0,1,0-1.42l12.84-12.08a1,1,0,0,1,1.41,0A174.17,174.17,0,0,0,170.22,369c96.32,0,174.69-78.36,174.69-174.69S266.54,19.63,170.22,19.63A174,174,0,0,0,61.71,57.39a1,1,0,0,0-.09,1.49L89.47,87.53A1,1,0,0,1,89,89.2L1.22,108.48A1,1,0,0,1,0,107.31c2.35-10.88,17.58-77,20.29-88.72A1,1,0,0,1,22,18.13L46.48,43.31a1,1,0,0,0,1.34.07A193.64,193.64,0,0,1,170.22,0C277.37,0,364.53,87.17,364.53,194.31Z"}))));
}

Reorder.defaultProps = {"viewBox":"0 0 364.53 388.63"};

module.exports = Reorder;

Reorder.default = Reorder;
